// src/pages/dashboards/UserDashboard.jsx
// User portal layout: nav + nested routes.

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "../../components/DashboardLayout";
import { BarChart3, Receipt, ClipboardList, Link2, Ticket } from "../../components/icons";

import UserOverview from "./user/UserOverview";
import UserExpenses from "./user/UserExpenses";
import UserReceipts from "./user/UserReceipts";
import UserSplits from "./user/UserSplits";
import UserSubscription from "./user/UserSubscription";

const NAV = [
  { label: "Overview", path: "/app", icon: BarChart3 },
  { label: "Tax", path: "/app/expenses", icon: Receipt },
  { label: "Splits", path: "/app/splits", icon: Link2 },
  { label: "Plan", path: "/app/subscription", icon: Ticket },
];

export default function UserDashboard() {
  return (
    <Routes>
      <Route element={<DashboardLayout nav={NAV} />}>
        <Route index element={<UserOverview />} />
        <Route path="expenses" element={<UserExpenses />} />
        <Route path="receipts" element={<UserReceipts />} />
        <Route path="splits" element={<UserSplits />} />
        <Route path="subscription" element={<UserSubscription />} />
        <Route path="*" element={<Navigate to="/app" replace />} />
      </Route>
    </Routes>
  );
}